export const qr = {
  seo: {
    title: 'QR-bestellen op locatie voor restaurants | Bistroo',
    description: 'Laat gasten zelfstandig bestellen en betalen via QR-code. Minder personeel nodig, hogere orderwaarde. Probeer 30 dagen gratis.',
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'QR-oplossing',
      pt3: 'op maat gemaakt voor jouw restaurant',
    },
    description:
      'Maak een kostenbesparend bestelproces aan tafel mogelijk, ontlast je medewerkers en verbeter je klantervaring vanaf de eerste scan tot en met de betaling.',
    button: 'Ontdek de QR-oplossing',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Vereenvoudig bestellen, maximaliseer klanttevredenheid',
      text: 'Geef je klant de vrijheid om te bestellen wat en wanneer ze willen. Optimaliseer de service, verhoog het gemak en verbeter de klantervaring met elke scan.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Update je QR-shop gemakkelijk',
      text: 'Alle updates in de Bistroo Manager worden direct gesynchroniseerd met de QR-stickers op je tafels, waardoor het aanpassen van het menu sneller en gemakkelijker is dan ooit.',
      cta: '',
    },
    paragraph_3: {
      title: 'Jouw stijl, jouw stickers',
      text: 'De stickers zijn van hoge kwaliteit en op maat gemaakt in jouw stijl en branding. Ze worden gemaakt van duurzaam en weerbestendig materiaal, waardoor ze geschikt zijn voor zowel binnen- als buitengebruik.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Makkelijke administratie',
      text: 'Van betalingen tot facturen, alles is volledig geautomatiseerd. Bestellingen worden verwerkt, betalingen kunnen worden gevolgd en facturen worden automatisch gegenereerd, waardoor jouw werklast drastisch verminderd.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Maak upselling een onderdeel van je bedrijf',
        text: 'Maak gebruik van de slimme upsell-opties en maak ze een natuurlijk onderdeel van elke bestelling ter plaatse waardoor de omzet moeiteloos groeit.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integraties',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Los personeelsuitdagingen op',
        text: 'Als er een uitdaging ontstaat, los je deze eenvoudig op met QR-tafelbestellingen.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Directe betalingen',
        text: 'Geen betaling meer aan de balie, klanten betalen tijdens het bestellen.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Kortingen en loyaliteit',
        text: 'Moedig klanten aan om de QR-oplossing te gebruiken door gebruik te maken van onze kortings- en loyaliteitsopties.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '”Een fijne samenwerking en een partner die 24/7 voor je klaarstaat.”',
    cta: 'Lees het volledige verhaal',
    name: 'De Wethouder',
    job_title: 'Sushi & Drink Club',
  },
  faq: {
    title_pt1: 'Alles over de',
    title_pt2: 'Bistroo QR-oplossing',
    items: [
      { q: 'Hoe werkt QR-bestellen voor mijn gasten?', a: 'Gasten scannen de QR-sticker op tafel met hun telefoon, zien direct het menu en bestellen en betalen zelfstandig. Geen app nodig, geen wachttijden aan de balie.' },
      { q: 'Hoe maak ik QR-stickers aan?', a: 'Na activatie van de QR-module in je Bistroo-account genereer je stickers op maat in je eigen huisstijl en branding. Bistroo drukt ze voor je af op duurzaam, weerbestendig materiaal.' },
      { q: 'Kunnen gasten direct betalen via de QR-code?', a: 'Ja. Gasten betalen direct bij het bestellen via iDEAL, creditcard, Apple Pay of Google Pay. Geen betaling meer aan de balie en geen wachttijden bij de rekening.' },
      { q: 'Wordt het menu automatisch gesynchroniseerd?', a: 'Ja. Alle wijzigingen die je maakt in de Bistroo Manager worden direct zichtbaar in de QR-shop. Je hoeft nooit op twee plekken je menu bij te werken.' },
      { q: 'Hoe verwerk ik QR-bestellingen in de keuken?', a: 'QR-bestellingen komen op dezelfde manier binnen als alle andere Bistroo-bestellingen: direct op het Bistroo Device, de keukenprinter of het kassasysteem. Geen extra scherm of handeling nodig.' },
      { q: 'Zijn de QR-stickers geschikt voor buiten gebruik?', a: 'Ja. De stickers zijn gemaakt van weerbestendig materiaal en zijn geschikt voor zowel binnen als buiten, ook op terrassen bij regen of zon.' },
      { q: 'Kan ik per tafel of zone aparte QR-codes aanmaken?', a: 'Ja. Je maakt per tafel, per ruimte of per terras aparte QR-codes aan. Zo weet je keuken altijd exact van welke tafel een bestelling afkomstig is.' },
      { q: 'Hoe stel ik upselling in voor QR-bestellingen?', a: 'Via de Bistroo Manager activeer je automatische upsell-suggesties. Bij het bestellen krijgt de gast passende extra\'s of combinaties voorgesteld, wat de gemiddelde orderwaarde verhoogt.' },
      { q: 'Wat zijn de kosten van de QR-oplossing?', a: 'De QR-module maakt deel uit van de Bistroo-pakketten. Afhankelijk van je pakket zijn er geen of minimale extra kosten. Neem een kijkje op de prijspagina voor het actuele overzicht.' },
      { q: 'Hoe ontvang ik notificaties van nieuwe QR-bestellingen?', a: 'Nieuwe bestellingen verschijnen direct op het Bistroo Device, de Manager-app en eventuele gekoppelde printers. Je ontvangt ook een pushmelding op de Bistroo-app zodat je nooit een bestelling mist.' },
    ],
  },
}
